import React from "react";
import { OrganisationSettings, Spinner } from "@design-system";
import { UPDATE_SETTINGS } from "../../../graphql/mutation";
import { useMutation, useSettings } from "../../../hooks";
import { FIND_LATEST_SETTINGS_QUERY } from "../../../graphql/query";
import { useQuery } from "@apollo/client";
import { GET_CURRENCIES } from "~/graphql/query/currencies-query";

export const OrganisationSettingsContainer = () => {
  const { loading: loadingSettings, settings } = useSettings();

  const { data: currencies, loading } = useQuery(GET_CURRENCIES);

  const [updateSettings, { loading: loadingCreateSettings }] = useMutation(UPDATE_SETTINGS, {
    update(cache, { data }) {
      const updateSettings = data?.updateSettings;
      if (updateSettings) {
        cache.writeQuery({
          query: FIND_LATEST_SETTINGS_QUERY,
          data: {
            findLatestSettings: updateSettings,
          },
        });
      }
    },
  });

  if (loadingSettings) {
    return <Spinner show />;
  }

  return (
    <OrganisationSettings
      loading={loading || loadingCreateSettings}
      settings={settings}
      currencies={currencies?.currencies ?? []}
      onUpdate={async (settingsData) => {
        console.log({ settingsData });
        await updateSettings({
          variables: {
            id: settings.id,
            data: {
              gpmDangerThreshold: { set: settingsData.gpmDangerThreshold },
              gpmWarningThreshold: { set: settingsData.gpmWarningThreshold ?? null },
              organisationPmsName: { set: settingsData.organisationPmsName },
              taxLabel: { set: settingsData.taxLabel },
              taxLevelPercent: { set: settingsData.taxLevelPercent },
              currency: { connect: { id: settingsData.currency.id } },
              administrationCharge: { set: settingsData.administrationCharge },
              decimalTimeInput: { set: settingsData.decimalTimeInput },
              autoCloseIntervalInDays: { set: settingsData.autoCloseIntervalInDays },
            },
          },
          context: {
            hasUpload: true,
          },
        });
      }}
    />
  );
};
